import { useState, useEffect } from 'react';
import API_URL from '../../config'

const useBlogsData = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Set the URI based on the environment
  const localUri = 'http://localhost:3000';

  useEffect(() => {
    // Fetch blogs from the server
    fetch(`${API_URL}/get-all-blogs`)
      .then(response => {
        if (!response.ok) {
          // setError('Network response was not ok');
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(data => {
        setBlogs(data);
        setLoading(false);
      })
      .catch(error => {
        setError(error.message);
        setLoading(false);
      });
  }, [localUri]);

  return { blogs, loading, error };
};

export default useBlogsData;
